module.exports = __webpack_public_path__ + "static/media/CompoundingInterestPic.a94ffec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/News/Assets/CompoundingInterestPic.png
// module id = 375
// module chunks = 0